import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {VoluntaryRequestReport} from 'src/app/shared/Models/VoluntaryRequestReport'
@Component({
  selector: 'app-voluntary-request-report',
  templateUrl: './voluntary-request-report.component.html',
  styleUrls: ['./voluntary-request-report.component.css']
})
export class VoluntaryRequestReportComponent  {
  ReportsInfo = new VoluntaryRequestReport()
  ReceiptBooks: any;
  ReceiptStatus: any;
  constructor(private router: Router) {
  
  }
  ngOnInit(): void {
  }
 
 

  Viewreports() {
  
    localStorage["ReportName"] = "VoluntaryRequestReport";
    localStorage.setItem('ReportFilter', JSON.stringify(this.ReportsInfo));

    this.router.navigate([]).then((result) => {
      window.open("/content/admin/reports-service", '_blank');
    });
  }
}
